function ActivateIntegration() {
  const inputIntegration = document.querySelector('input[name=ativar-integracao]')
  const btnIntegration = document.querySelector('span[name=ativar-integracao]');

  if (btnIntegration !== null) {
    $(btnIntegration).one('click', function () {
      if (inputIntegration.checked) {
        window.location = route('app.settings.integracoes.matera.ativar-integracao');
      } else {
        window.location = route('app.settings.integracoes.matera.interromper-integracao');
      }
    });
  }
}

module.exports = ActivateIntegration;
